module.exports = __webpack_public_path__ + "static/media/face-smile-filled.43fbf538.svg";